var _circle, _circle2, _circle3, _circle4, _circle5, _circle6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHerobackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 704,
    height: 828,
    viewBox: "0 0 704 828",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 348.366,
    cy: 479.634,
    r: 135.817,
    stroke: "#20B486",
    strokeOpacity: 0.25
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 349.207,
    cy: 480.476,
    r: 222.488,
    stroke: "#20B486",
    strokeOpacity: 0.25
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 348.366,
    cy: 479.634,
    r: 288.963,
    stroke: "#20B486",
    strokeOpacity: 0.25
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 348.366,
    cy: 479.634,
    r: 347.866,
    stroke: "#20B486",
    strokeOpacity: 0.25
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 697,
    cy: 502,
    r: 6,
    stroke: "#3300FF",
    strokeWidth: 2
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 113,
    cy: 219,
    r: 12,
    stroke: "#FF9E00",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHerobackground);
export default __webpack_public_path__ + "static/media/herobackground.33d87219aafae2baf6f22c597eec036e.svg";
export { ForwardRef as ReactComponent };